/* Cheerful Buddha shared behaviour (Phase 1). Loaded with defer from layout/theme.liquid. */
(function () {
  // Decorative looping videos (snippets/cb-video.liquid): paused for visitors who prefer reduced
  // motion, plus a pause/play button for everyone (WCAG 2.2.2). The button renders hidden, so it
  // only shows when this script can run it; its label and icon follow the video's real state
  // (autoplay can also be blocked by the browser, e.g. iOS Low Power Mode).
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function videoFor(button) {
    var prev = button.previousElementSibling;
    if (prev && prev.matches('video[data-cb-video]')) return prev;
    var id = button.getAttribute('aria-controls');
    var video = id ? document.getElementById(id) : null;
    return video && video.matches('video[data-cb-video]') ? video : null;
  }

  function syncToggle(button) {
    var video = videoFor(button);
    if (!video) return;
    button.toggleAttribute('data-paused', video.paused);
    button.setAttribute('aria-label', video.paused ? button.dataset.labelPlay : button.dataset.labelPause);
  }

  function onPlayState(event) {
    document.querySelectorAll('[data-cb-video-toggle]').forEach(function (button) {
      if (videoFor(button) === event.target) syncToggle(button);
    });
  }

  // Performance: cb-video renders films with preload="none" and no autoplay attribute, so a film
  // only downloads and plays while it is on screen (or about to be), and pauses when it leaves.
  // A film the visitor paused stays paused; one they started plays even with reduced motion.
  function wantsPlay(v) {
    if (v.hasAttribute('data-cb-user-play')) return true;
    if (v.hasAttribute('data-cb-user-paused')) return false;
    return !(reduce && reduce.matches);
  }
  function autoPlay(v) {
    if (!v.paused || !wantsPlay(v)) return;
    var started = v.play();
    if (started && started.catch) started.catch(function () {});
  }
  var inView = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            v.toggleAttribute('data-cb-in-view', entry.isIntersecting);
            if (entry.isIntersecting) autoPlay(v);
            else if (!v.paused) v.pause();
          });
        },
        { rootMargin: '200px 0px' }
      )
    : null;
  function onPlaying(event) {
    event.target.setAttribute('data-cb-playing', '');
  }

  function initVideos() {
    document.querySelectorAll('video[data-cb-video]').forEach(function (v) {
      if (reduce && reduce.matches && !v.hasAttribute('data-cb-user-play')) {
        v.removeAttribute('autoplay');
        v.pause();
      }
      if (!v.hasAttribute('data-cb-video-ready')) {
        v.setAttribute('data-cb-video-ready', '');
        v.addEventListener('play', onPlayState);
        v.addEventListener('pause', onPlayState);
        v.addEventListener('playing', onPlaying);
        if (v.hasAttribute('data-cb-autoplay')) {
          if (inView) inView.observe(v);
          else autoPlay(v);
        }
      } else if (v.hasAttribute('data-cb-in-view')) {
        autoPlay(v);
      }
    });
    document.querySelectorAll('[data-cb-video-toggle]').forEach(function (button) {
      if (!videoFor(button)) return;
      button.hidden = false;
      syncToggle(button);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-cb-video-toggle]') : null;
    var video = button ? videoFor(button) : null;
    if (!video) return;
    if (video.paused) {
      video.setAttribute('data-cb-user-play', '');
      video.removeAttribute('data-cb-user-paused');
      var started = video.play();
      if (started && started.catch) {
        started.catch(function () {
          video.pause();
          syncToggle(button);
        });
      }
    } else {
      video.removeAttribute('data-cb-user-play');
      video.setAttribute('data-cb-user-paused', '');
      video.pause();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideos);
  else initVideos();
  document.addEventListener('shopify:section:load', initVideos);
  if (reduce && reduce.addEventListener) reduce.addEventListener('change', initVideos);

  // Horizon's own pages (cart, search, other products) read --header-height and
  // --sticky-header-offset for their sticky parts, and --header-group-height for sections sized to
  // the viewport. Horizon's header set these; the cb header replaces it and sets them itself
  // (sections/cb-header.liquid: --header-height is the stuck bar's height, 0px if the header
  // isn't sticky, and --sticky-header-offset follows it).

  // Arriving at an anchor from another page (/#reviews, /#subscribe): the browser works out its
  // smooth jump before the page has settled (web font swap, late layout), so it can stop short of
  // or past the heading. Each time scrolling pauses in the first few seconds, and once the fonts
  // are in, the anchor is put back at its scroll-margin (which includes the sticky header's height,
  // see cb-header), unless the visitor has scrolled, tapped or typed, or something else has taken
  // focus (the newsletter message does).
  function settleHashTarget() {
    var id = location.hash.slice(1);
    if (!id) return;
    // Only a fresh arrival: on Back, Forward or reload the browser (or Horizon) puts the visitor
    // back where they were, and that must win (Technical QA round 3).
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type !== 'navigate') return;
    var target = null;
    try {
      target = document.getElementById(decodeURIComponent(id));
    } catch (error) {
      return;
    }
    if (!target) return;
    var moved = false;
    var timer = 0;
    function stop() {
      moved = true;
    }
    function snap() {
      var active = document.activeElement;
      if (moved || (active && active !== document.body && active !== document.documentElement)) return;
      // Look the anchor up again: a section may hand the id to a better target once its script has run
      // (the product page gives #notify-me to the size picker, so the sizes and the form both show).
      var current = null;
      try {
        current = document.getElementById(decodeURIComponent(id));
      } catch (error) {
        current = null;
      }
      if (!current) current = target.isConnected ? target : null;
      if (!current) return;
      target = current;
      var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      if (Math.abs(target.getBoundingClientRect().top - margin) > 2) {
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }
    function snapSoon() {
      clearTimeout(timer);
      timer = setTimeout(snap, 200);
    }
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (type) {
      window.addEventListener(type, stop, { once: true, passive: true, capture: true });
    });
    document.addEventListener('scroll', snapSoon, { capture: true, passive: true });
    setTimeout(function () {
      document.removeEventListener('scroll', snapSoon, { capture: true });
    }, 4000);
    window.addEventListener('load', snapSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(snapSoon);
  }
  settleHashTarget();

  // Shopify's cookie banner (Settings > Customer privacy; UK and EEA visitors only). Shopify's script
  // adds <section id="shopify-pc__banner"> to <body> after the page loads and shows or hides it with an
  // inline display style. While it shows, html gets .cb-consent-open and --cb-consent-h (the space it
  // takes at the bottom of the screen), which cb-base.css uses to move our own bottom bars out of its
  // way. Where the banner never appears, this only watches <body>'s direct children.
  var CONSENT_ID = 'shopify-pc__banner';
  var consentBanner = null;
  var consentResize = null;
  var consentStyle = null;
  var consentFrame = 0;

  // Batched to the next frame, so the ResizeObserver never resizes what it is observing mid-loop.
  function syncConsentSoon() {
    if (consentFrame) return;
    consentFrame = window.requestAnimationFrame(function () {
      consentFrame = 0;
      syncConsent();
    });
  }

  function syncConsent() {
    var root = document.documentElement;
    var el = consentBanner;
    var open = Boolean(el && el.isConnected && getComputedStyle(el).display !== 'none');
    root.classList.toggle('cb-consent-open', open);
    if (!open) {
      root.style.removeProperty('--cb-consent-h');
      return;
    }
    var bottom = parseFloat(getComputedStyle(el).bottom) || 0;
    root.style.setProperty('--cb-consent-h', Math.ceil(el.getBoundingClientRect().height + bottom) + 'px');
  }

  function watchConsent() {
    var el = document.getElementById(CONSENT_ID);
    if (el === consentBanner) return;
    if (consentResize) consentResize.disconnect();
    if (consentStyle) consentStyle.disconnect();
    consentResize = consentStyle = null;
    consentBanner = el;
    if (el) {
      if (window.ResizeObserver) {
        consentResize = new ResizeObserver(syncConsentSoon);
        consentResize.observe(el);
      }
      consentStyle = new MutationObserver(syncConsentSoon);
      consentStyle.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    syncConsent();
  }

  // Theme preview only: html.cb-preview-bar while Shopify's preview bar (a <div> it adds to <body>)
  // is on the page, so cb-base.css lifts the banner above it. A class, not html:has(), see there.
  function syncPreviewBar() {
    var on = Boolean(document.getElementById('PBarNextFrameWrapper'));
    var root = document.documentElement;
    if (root.classList.contains('cb-preview-bar') !== on) root.classList.toggle('cb-preview-bar', on);
  }

  function onBodyChildren() {
    syncPreviewBar();
    watchConsent();
  }

  function startConsentWatch() {
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(onBodyChildren).observe(document.body, { childList: true });
    onBodyChildren();
  }
  if (document.body) startConsentWatch();
  else document.addEventListener('DOMContentLoaded', startConsentWatch);
  // Shopify fires this once a choice is saved (the banner hides itself at the same moment).
  document.addEventListener('visitorConsentCollected', syncConsentSoon);
  window.addEventListener('resize', function () {
    if (consentBanner) syncConsentSoon();
  });

  // Footer "Cookie preferences" link (sections/cb-footer.liquid): reopens the banner's preferences
  // where Shopify's banner script runs; anywhere else the link simply opens its page (privacy policy).
  document.addEventListener('click', function (event) {
    var link = event.target instanceof Element ? event.target.closest('a[data-cb-cookie-prefs]') : null;
    var banner = window.privacyBanner;
    if (!link || !banner || typeof banner.showPreferences !== 'function') return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    function followLink() {
      window.location.href = link.href;
    }
    try {
      var shown = banner.showPreferences();
      if (shown && typeof shown.catch === 'function') shown.catch(followLink);
    } catch (error) {
      followLink();
    }
  });

  // Trustpilot's widget script (loaded by the Trustpilot app) fills each TrustBox once, when the page
  // loads. A TrustBox added or changed in the theme editor arrives later, so ask the script to fill it
  // (snippets/cb-trustbox.liquid).
  document.addEventListener('shopify:section:load', function (event) {
    var trustpilot = window.Trustpilot;
    if (!trustpilot || typeof trustpilot.loadFromElement !== 'function') return;
    event.target.querySelectorAll('.trustpilot-widget').forEach(function (box) {
      trustpilot.loadFromElement(box, true);
    });
  });
})();
